
import type { PropType } from 'vue'
import type { ToolsMessages } from '../../models/i18n/tools.messages'
import { defineComponent } from 'vue'
import { UiTooltip } from '../../components/keen-ui'
import { ConfigurationToolIdEnum } from '../../enums/configuration-tool-id.enum'

export default defineComponent({
  name: 'ConfigurationFeaturesStatus',
  components: {
    UiTooltip,
  },
  props: {
    tools: {
      type: Array as PropType<Array<ConfigurationToolIdEnum>>,
      default: () => [
        ConfigurationToolIdEnum.ATTRIBUTES_RANKING,
        ConfigurationToolIdEnum.PRODUCTS_RANKING,
      ],
    },
    messages: {
      type: Object as PropType<ToolsMessages['configurations']['fields']['features']>,
      required: true,
    },
    hasProductsRanking: Boolean,
    hasAttributesRanking: Boolean,
    hasHiddenAttributes: Boolean,
    hasPinnedProducts: Boolean,
    hasHiddenProducts: Boolean,
    hasFacets: Boolean,
  },
  computed: {
    features() {
      return {
        ...(this.tools.includes(ConfigurationToolIdEnum.FACETS_CONFIG) && {
          facets: {
            name: this.messages.facets,
            icon: 'facets',
            modified: this.hasFacets,
          },
        }),
        ...(this.tools.includes(ConfigurationToolIdEnum.ATTRIBUTES_RANKING) && {
          attributes: {
            name: this.messages.attributes,
            icon: 'attributes',
            modified: this.hasAttributesRanking,
          },
        }),
        ...(this.tools.includes(ConfigurationToolIdEnum.HIDDEN_ATTRIBUTES) && {
          hiddenAttributes: {
            name: this.messages.hiddenAttributes,
            icon: 'hide',
            modified: this.hasHiddenAttributes,
          },
        }),
        ...(this.tools.includes(ConfigurationToolIdEnum.PRODUCTS_RANKING) && {
          products: {
            name: this.messages.products,
            icon: 'boostbury',
            modified: this.hasProductsRanking,
          },
        }),
        ...(this.tools.includes(ConfigurationToolIdEnum.PINNED_PRODUCTS) && {
          pinnedProducts: {
            name: this.messages.pinnedProducts,
            icon: 'pin',
            modified: this.hasPinnedProducts,
          },
        }),
        ...(this.tools.includes(ConfigurationToolIdEnum.HIDDEN_PRODUCTS) && {
          hiddenProducts: {
            name: this.messages.hiddenProducts,
            icon: 'hide',
            modified: this.hasHiddenProducts,
          },
        }),
      }
    },
  },
})
